import { InMemoryCache } from '@apollo/client/core';
import { CachePersistor } from 'apollo-cache-persist';
import { ApolloClient, ApolloLink, createHttpLink } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { RestLink } from 'apollo-link-rest';
import fetch from 'isomorphic-fetch';
import { AuthorizationHeadersLink } from './AuthorizationHeadersLink';
import getUserFriendlyErrorMessage from './errors';
import { observableQueryToReadable } from './observable';
import { notifications } from './notifications';
const cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                memberships: {
                    merge(existing, incoming, { mergeObjects }) {
                        if (incoming && !Array.isArray(incoming.data)) {
                            return mergeObjects(existing, { data: [incoming.data] });
                        }
                        return mergeObjects(existing, incoming);
                    },
                },
            },
        },
    },
});
// For historical reason are not restore from localStorage here.
export const cachePersistor = new CachePersistor({
    cache,
    storage: window.localStorage,
    maxSize: false,
    debug: process.env.NODE_ENV !== 'production',
});
export const authLink = new AuthorizationHeadersLink();
const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
        graphQLErrors.map(({ message }) => notifications.error(`GraphQL error while execute ${operation.operationName}: ${message}`));
    }
    if (networkError) {
        if ('result' in networkError) {
            if ('message' in networkError.result) {
                notifications.error(networkError.result['message']);
            }
            else if ('data' in networkError.result) {
                const { code, message: rawMessage } = networkError.result['data'];
                const pathname = new URL(networkError.response.url).pathname;
                const message = getUserFriendlyErrorMessage(code, pathname) || rawMessage;
                notifications.error(message);
            }
        }
        else {
            notifications.error(networkError.message);
        }
    }
});
const restLink = new RestLink({
    uri: 'process.env.OMNI_URL',
    customFetch: fetch,
});
// Membership - https://hdcmembership.{env}.hagerty.com/graphql
const membershipLink = createHttpLink({
    uri: 'process.env.MEMBERSHIP_URL',
});
const restLinkFrom = ApolloLink.from([authLink, errorLink, restLink]);
const link = ApolloLink.from([restLinkFrom, membershipLink]);
export const client = new ApolloClient({ cache, link });
/**
 *
 * @param options the options to used in ApolloClient.watchQuery
 */
export const query = (options) => {
    return observableQueryToReadable(client.watchQuery(options));
};
export default client;
